import { gql } from 'urql';

import { WISHLIST_FRAGMENT } from 'gql/fragments/wishList';

export const ADD_ITEM_TO_WISHLIST_MUTATION = gql`
  mutation AddItemToWishList($input: AddItemToWishListInput!) {
    addItemToWishList(input: $input) {
      ...wishListFields
    }
  }

  ${WISHLIST_FRAGMENT}
`;

export const UPDATE_ITEM_IN_WISHLIST_MUTATION = gql`
  mutation UpdateItemInWishList($input: UpdateItemInWishListInput!) {
    updateItemInWishList(input: $input) {
      ...wishListFields
    }
  }

  ${WISHLIST_FRAGMENT}
`;

export const REMOVE_ITEM_FROM_WISHLIST_MUTATION = gql`
  mutation RemoveItemFromWishList($input: RemoveItemFromWishListInput!) {
    removeItemFromWishList(input: $input)
  }
`;
